import { useCallback, useRef } from 'react';

export function usePasteInput() {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const setFocus = useCallback(() => {
    if (!inputRef.current) return;
    inputRef.current.focus();
  }, [inputRef]);

  const setBlur = useCallback(() => {
    if (!inputRef.current) return;
    inputRef.current.blur();
  }, [inputRef]);

  return { inputRef, setFocus, setBlur };
}
